export default "__VITE_ASSET__ChpLv3yA__"